// @core/stores/form/FormFormTypeStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { formApi } from '@core/api';
import type {
  FormTypeDefinitionResponse,
  ListFormTypesResponse,
  RegisterFormTypeRequest,
  UpdateFormTypeRequest,
} from '@core/types/form';

class FormFormTypeStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Delete form type
   */
  async DeleteFormType(type_id: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await formApi.DeleteFormType(type_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get form type
   */
  async GetFormType(type_id: string): Promise<FormTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await formApi.GetFormType(type_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List form types
   */
  async ListFormTypes(params?: { cursor?: string | number | boolean; direction?: string | number | boolean; limit?: string | number | boolean; product_id?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListFormTypesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await formApi.ListFormTypes(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Register form type
   */
  async RegisterFormType(data: RegisterFormTypeRequest): Promise<FormTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await formApi.RegisterFormType(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update form type
   */
  async UpdateFormType(type_id: string, data: UpdateFormTypeRequest): Promise<FormTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await formApi.UpdateFormType(type_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const formFormTypeStore = new FormFormTypeStore();
